"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDom = _interopRequireDefault(require("react-dom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APPCUES_APP_ROOT_CLASS = ".apc-react-body";

var Portal = function Portal(_ref) {
  var children = _ref.children;
  var appBody = document.querySelector(APPCUES_APP_ROOT_CLASS) || document.body;
  return _reactDom.default.createPortal(children, appBody);
};

var _default = Portal;
exports.default = _default;